import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductImportationStatusEnum } from 'src/app/Enums/ProductImportationStatusEnum';
import { ProductImportation } from 'src/app/models/Product/Import/ProductImportation.model';
import { ProductImportationService } from 'src/app/services/product/importation/product-importation.service';

@Component({
  selector: 'app-product-import-history-dialog',
  templateUrl: './product-import-history-dialog.component.html',
  styleUrls: ['./product-import-history-dialog.component.scss']
})
export class ProductImportHistoryDialogComponent implements OnInit, OnDestroy {

  public data: { id: number, status: ProductImportationStatusEnum, fileName: string, historyMessage: string, progress: number | undefined }[] = [];
  public Enum = ProductImportationStatusEnum;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<ProductImportHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public injectData: ProductImportation[] | null,
    private importService: ProductImportationService,
    private router: Router,
  ) {
    this.setData(injectData ?? []);
  }

  ngOnInit(): void {
    this.getHistory();
    let isFirstPoll = true;
    this.importService.pollWhileVisible(async () => {
      const mustFetch = isFirstPoll || this.data.some((d) => this.isInProgress(d.status));
      isFirstPoll = false;
      if (mustFetch)
        await this.importService.apiGetProductImportationPaginated().catch(() => {});
    }).pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async reviewImportation(id: number) {
    await this.importService.loadProductImportation(id);
    this.importService.loadColumnMap("");
    this.dialogRef.close();
    this.router.navigate(['/product'],{skipLocationChange:false}).then(()=>{
      this.router.navigate(['/product/import/review'], {skipLocationChange: true})
    });
  }

  private isInProgress(status: ProductImportationStatusEnum): boolean {
    return status == ProductImportationStatusEnum.Received
      || status == ProductImportationStatusEnum.ReadingFile
      || status == ProductImportationStatusEnum.ValidatingProducts
      || status == ProductImportationStatusEnum.SavingProducts;
  }

  private async getHistory() {
    this.importService.getImportationHistory().pipe(takeUntil(this.destroy$)).subscribe((history) => {
      this.setData(history);
    });
  }

  private setData(history: ProductImportation[]) {
    this.data = history.map((d) => {
      return {
        id: d.id,
        status: d.status,
        fileName: d.originalFileName,
        historyMessage: this.getMessageToShow(d.status, d.statusChangedAt),
        progress: d.progressPercentage
      }
    });
  }

  private getMessageToShow(status: ProductImportationStatusEnum, date: Date) {
    let msg = " ";
    switch (status) {
      case ProductImportationStatusEnum.Aborted:
        msg += "cancelado pelo usuário"
        break;
      case ProductImportationStatusEnum.Completed:
        msg += "importado com sucesso"
        break;
      case ProductImportationStatusEnum.Error:
        msg += "falha na importação"
        break;
      case ProductImportationStatusEnum.ReadingFile:
      case ProductImportationStatusEnum.Received:
      case ProductImportationStatusEnum.SavingProducts:
      case ProductImportationStatusEnum.ValidatingProducts:
        msg += "em andamento"
        return msg;
        break;
      case ProductImportationStatusEnum.ValidatedProducts:
        msg += "aguardando revisão"
        return msg;
        break;
    }

    date = new Date(date);

    msg += " às "+
      date.toLocaleTimeString("pt-BR", {hour: "2-digit", minute: "2-digit", second: undefined})+
      " de "+
      date.toLocaleDateString("pt-BR", {day: "2-digit", month: "2-digit", year: "2-digit"});

    return msg;
  }
}
